import GenericPokkService from "#/data-layer/GenericPokkService";
import * as species from "#/utils/SpeciesScope";

/**
 * Service for fetching a list of KODOBR
 */
export class BreedingValuesKodaIzracunService extends GenericPokkService {
  constructor() {
    super({
      baseUrl: "/api/plemenske_vrednosti/kode_obr",
    });
  }

  /**
   * Constructs the API endpoint URL based on the baseUrl and any additional parts provided.
   *
   * @param  {...any} parts
   * @returns string - The constructed API endpoint URL.
   */
  #endpoint(...parts) {
    return [this.baseUrl, ...parts.filter(Boolean)].join("/");
  }

  async query() {
    return this.client
      .get(this.#endpoint())
      .then(({ data }) => {
        const all = (data?.list ?? [])
          .filter((k) => species.has(k.species))
          .reverse()
          .map((kod) => kod.kodaIzracun);

        // unique values
        const list = [...new Set(all)];

        return { list };
      })
      .catch((err) => {
        const { status, data } = err.response || {};

        throw {
          ...data,
          status,
          message: data?.resultMessages || err.message,
          response: err.response,
        };
      });
  }
}
